import React from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';
import { useTranslations } from 'next-intl';
import { QuantityDisplayProps } from './types/ProductQuantityDisplay';

function QuantityDisplay({
  quantity,
  disableUpdate,
  fixedQuantity,
  updateQuantity,
}: Readonly<QuantityDisplayProps>) {
  const t = useTranslations('ProductQuantityDisplay');
  // A fixed quantity can only go down, but above 1 the customer still has to see where it is
  const isQuantityShown = !fixedQuantity || quantity > 1;

  if (disableUpdate) { return null; }
  return (
    <div className="flex">
      {((fixedQuantity && !disableUpdate) || !disableUpdate) && (
        <button
          type="button"
          onClick={() => updateQuantity(quantity - 1)}
          className={`flex h-10 w-10 items-center justify-center rounded-l-md border  border-neutral-10 text-xl text-neutral-80 hover:bg-neutral-10 ${isQuantityShown ? 'border-r-0' : 'rounded-md border-r'}`}
          aria-label={quantity === 1 ? t('removeItem') : t('decreaseQuantity')}
        >
          {quantity === 1 ? <TrashIcon className="h-5 w-5" aria-hidden="true" /> : '−'}
        </button>
      )}
      {isQuantityShown && (
        <p
          className={`h-10 w-10 border-b border-t border-neutral-10 pt-2  text-center font-medium ${fixedQuantity ? 'rounded-r-md border-r' : ''}`}
        >
          {quantity}
        </p>
      )}
      {!disableUpdate && !fixedQuantity && (
        <button
          type="button"
          onClick={() => updateQuantity(quantity + 1)}
          className="h-10 w-10 rounded-r-md border-y border-r border-neutral-10 text-xl text-neutral-80 hover:bg-neutral-10"
          aria-label={t('increaseQuantity')}
        >
          +
        </button>
      )}
    </div>
  );
}

export default QuantityDisplay;
